import groupBy from "lodash/groupBy";
import {COUNTERTOP_GROUP} from "../../kvComponent/core/constants";
import {getCurrentLayout} from "../../appLayout";
import {getNextWizardSteps} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import {
  getCorrectedWizardGroupForFeature,
  wizardGroupHasFeatureIncluded
} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {changeCartFeature, removeFromCart} from "../../../actions/actionFunctions";
import {setWizardSelectedValues} from "../../../actions/wizardFunctions";
import Config from "../../../config";
import {updateQuoteWithSQFTData} from "../../sqft/helpers/sqftQuotesHelper";

export const replaceCartItemsAndWizardStepsWithNewSelectedFeature = () => {
  return (dispatch, getState) => {
    const store = getState();
    const {wizardSelectedValues, wizardActiveStep, wizardActiveItem, wizardConflictingSteps} = store.wizardState;
    const {cartItems, cartItemEditFeature} = store.cartState;
    const {selectionFeatureInfo, selectionInfoQuantity} = store.selectionState;

    const cartItemsToRemove = cartItems.filter(cartItem => {
      return wizardConflictingSteps.some(confObject => confObject.cartItemId === cartItem.id);
    });

    if (Config.isDevMode()) {
      console.log("cartItemsToRemove", cartItemsToRemove, cartItems);
    }

    const sourceOfConflict = wizardConflictingSteps.reduce((min, obj) => obj.stepIndex < min.stepIndex ? obj : min); // find first conflict

    let replaceWithNewFeature = null;
    // 0) here we need to find source feature with should replace countertops and backsplashes
    if (sourceOfConflict && wizardSelectedValues[sourceOfConflict.stepIndex]
      && wizardSelectedValues[sourceOfConflict.stepIndex].selectedFeature
      && COUNTERTOP_GROUP.some(partId => wizardSelectedValues[sourceOfConflict.stepIndex].selectedFeature.partId === partId)) {
      replaceWithNewFeature = wizardSelectedValues[sourceOfConflict.stepIndex].selectedFeature;
    }

    const layout = getCurrentLayout();
    const currentWizardSteps = getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    if (Config.isDevMode()) {
      console.log("nextWizardSteps", currentWizardSteps);
    }
    let stillRemoveCartItems = [...cartItemsToRemove];
    let editFeatureToSet = false;
    let currentFeatureInfoUpdated = false;
    const updatedCartItems = [];

    cartItemsToRemove.forEach((cartItem) => {
      if (COUNTERTOP_GROUP.some(partId => cartItem.partId === partId)) {
        const featureFromCurrentLayout = layout.getFeatureBySku(
          replaceWithNewFeature?.dbFeature?.sharedFeatureName,
          cartItem.partId,
          false,
          true
        );
        if (featureFromCurrentLayout) {
          const toReplaceStepFound = currentWizardSteps.find(step => {
            if (step.stepGroups.length !== 1 || (step.stepGroups[0].groupName !== cartItem.cartFeature.dbFeature.groupName)) {
              return false
            }
            return wizardGroupHasFeatureIncluded(step.stepGroups[0], featureFromCurrentLayout)
          })
          if (toReplaceStepFound) {
            const correctedWizardGroup = getCorrectedWizardGroupForFeature(toReplaceStepFound.stepGroups[0], featureFromCurrentLayout);
            // 1) replace cartItem with the NEW cart feature and wizard groups
            const newReplacedCartItem = Object.assign({}, cartItem, {
              cartFeature: featureFromCurrentLayout,
              fromWizardId: wizardActiveItem.id,
              fromWizardStep: toReplaceStepFound.stepIndex,
              fromWizardGroupId: correctedWizardGroup.id,
            });
            if (selectionFeatureInfo && !currentFeatureInfoUpdated && (selectionFeatureInfo.dbFeature.id === featureFromCurrentLayout.dbFeature.id)) {
              newReplacedCartItem.quantity = selectionInfoQuantity;
              currentFeatureInfoUpdated = true;
            }
            if (Config.isDevMode()) {
              console.log("newReplacedCartItem!", newReplacedCartItem);
            }
            dispatch(changeCartFeature(newReplacedCartItem));
            // 2) set new selections in the wizard
            dispatch(setWizardSelectedValues({
              [toReplaceStepFound.stepIndex]: {
                wizardGroup: correctedWizardGroup,
                selectedFeature: featureFromCurrentLayout,
                partId: featureFromCurrentLayout.partId,
              }
            }));
            // 3) replace cartItem edit feature, as we just changed cartItem we entered
            if (cartItemEditFeature && !editFeatureToSet && (toReplaceStepFound.stepIndex === wizardActiveStep)) {
              editFeatureToSet = newReplacedCartItem;
            }
            // we don't need to remove it from cart below, we just replaced it
            stillRemoveCartItems = stillRemoveCartItems.filter(cI => cI.id !== cartItem.id);
            updatedCartItems.push(newReplacedCartItem);
            return
          }
        }
      }

      dispatch(removeFromCart(cartItem)); // no same feature in new flow, delete it
    });
    if (updatedCartItems.length) {
      dispatch(updateQuoteSqftFeatureIds(updatedCartItems));
    }

    return {
      cartItemsToRemove: stillRemoveCartItems,
      currentFeatureInfoUpdated,
      editFeatureToSet
    }
  }
}

export const updateQuoteSqftFeatureIds = (cartItems) => (dispatch, getState) => {
  const store = getState();
  const { quotes } = store.quotesState;
  const itemsByQuote = groupBy(cartItems, 'currentQuote');

  Object.entries(itemsByQuote).forEach(([quoteId, cartItems]) => {
    const quote = quotes[Number(quoteId)];
    if (!quote) {
      return;
    }

    const { sqFtCalcData } = quote;
    const newSqFtCalcData = {
      ...sqFtCalcData,
      countertops: sqFtCalcData.countertops.map(countertop => {
        const cartItemFound = cartItems.find(cartItem =>
          (cartItem.sqftId === countertop.id) ||
          (Array.isArray(cartItem.sqftIds) && cartItem.sqftIds.includes(countertop.id))
        );
        return cartItemFound
          ? { ...countertop, featureId: cartItemFound.cartFeature.dbFeature.id }
          : countertop;
      })
    };
    updateQuoteWithSQFTData(newSqFtCalcData, Number(quoteId));
  });
};
